/* New Comfort · productpagina 2026 — iRest Grandease+ A550:
   galerij met 360-draaibeeld, subnav, video, kleurschuif, maten, specs */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s);},
      $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function stickOff(){ var h=$('sticky-header')||$('.section-header'); var b=h?h.getBoundingClientRect():null; var sub=$('.ncp-sub');
    return (b&&b.bottom>0?b.bottom:0)+(sub?sub.offsetHeight:0)+8; }
  function go(id){ var t=document.getElementById(id); if(!t) return;
    window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-stickOff(),behavior:'smooth'}); }

  /* ---- 1 · galerij naar de mediakolom van main-product ---- */
  var gal=$('#ncpGal'), media=$('.product__media-wrapper');
  if(gal&&media){ media.classList.add('ncp-media'); $$(':scope > *',media).forEach(function(c){ c.style.display='none'; });
    media.insertBefore(gal,media.firstChild); gal.hidden=false; }

  if(gal){
    var stage=$('#stage',gal), img=$('#stageImg',gal), bg=$('.gal__bg',gal);
    var press=function(t){ $$('.thumb',gal).forEach(function(x){ x.setAttribute('aria-pressed', x===t?'true':'false'); }); };

    /* 360-draaibeeld: acht opnamen, slepen of met de pijltjes */
    var t360=$('.thumb[data-360]',gal), hoeken=[], frames=[], stand=7, geladen=false,
        deg=$('#galDeg',gal), ticks=$$('.gal__ticks i',gal);
    if(t360){
      hoeken=t360.getAttribute('data-360').split(',');
      var basis=t360.getAttribute('data-360base');
      frames=hoeken.map(function(h){ return basis+h+'.jpg?width=1100'; });
      stand=hoeken.length-1;
    }
    var toon=function(i){
      if(!frames.length) return;
      stand=((i%frames.length)+frames.length)%frames.length;
      img.src=frames[stand];
      if(deg) deg.value=hoeken[stand].replace(/^0+(?=\d)/,'')+'\u00B0';
      ticks.forEach(function(t,k){ t.classList.toggle('on',k===stand); });
    };
    var open360=function(){
      press(t360);
      stage.classList.remove('is-photo'); stage.classList.add('is-360');
      if(bg) bg.style.backgroundImage='';
      if(!geladen){ geladen=true; frames.forEach(function(u){ var i=new Image(); i.src=u; }); }
      toon(stand);
    };

    $$('.thumb',gal).forEach(function(t){
      t.addEventListener('click',function(){
        var jump=t.getAttribute('data-jumpto');
        if(jump){ go(jump); return; }
        if(t===t360){ open360(); return; }
        press(t);
        stage.classList.remove('is-360'); stage.classList.add('is-photo');
        var src=t.getAttribute('data-full');
        img.src=src; if(bg) bg.style.backgroundImage='url("'+src+'")';
      });
    });

    $$('.gal__deg button',gal).forEach(function(b){
      b.addEventListener('click',function(){ toon(stand + (+b.getAttribute('data-spin'))); });
    });

    if(t360 && window.PointerEvent){
      var sleept=false, vorigeX=0, opgespaard=0, STAP=26;
      stage.addEventListener('pointerdown',function(e){
        if(!stage.classList.contains('is-360')) return;
        sleept=true; vorigeX=e.clientX; opgespaard=0;
        try{ stage.setPointerCapture(e.pointerId); }catch(err){}
      });
      stage.addEventListener('pointermove',function(e){
        if(!sleept) return;
        opgespaard += e.clientX-vorigeX; vorigeX=e.clientX;
        while(Math.abs(opgespaard)>=STAP){
          var richting = opgespaard>0 ? 1 : -1;
          toon(stand-richting); opgespaard -= richting*STAP;
        }
      });
      ['pointerup','pointercancel','pointerleave'].forEach(function(n){
        stage.addEventListener(n,function(){ sleept=false; });
      });
    }
  }

  /* ---- 2 · subnav ---- */
  $$('[data-jump]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); go(a.getAttribute('data-jump'));
    if(a.closest('.sub__links')) $$('.sub__links a').forEach(function(x){ x.classList.toggle('on',x===a); }); }); });
  var subBuy=$('.ncp-sub .sub__buy a');
  if(subBuy) subBuy.addEventListener('click',function(e){ e.preventDefault(); go('showroom'); });

  /* ---- 3 · video ---- */
  var vbox=$('#ncVideo');
  if(vbox){
    var vid=$('video',vbox), poster=$('.vbox__poster',vbox), pimg=$('.vbox__poster img',vbox),
        picks=$$('.vpick button'), meta=$('#ncVmeta');
    var load=function(btn,play){
      picks.forEach(function(b){ b.setAttribute('aria-pressed', b===btn?'true':'false'); });
      if(vid.getAttribute('src')!==btn.getAttribute('data-src')){
        vid.setAttribute('src',btn.getAttribute('data-src')); vid.load();
      }
      if(pimg) pimg.src=btn.getAttribute('data-poster');
      if(meta) meta.textContent=btn.getAttribute('data-meta')||'';
      if(play){ vbox.classList.add('is-on'); vid.play().catch(function(){}); }
    };
    picks.forEach(function(b){ b.addEventListener('click',function(){ load(b, vbox.classList.contains('is-on')); }); });
    if(poster) poster.addEventListener('click',function(){
      var cur=picks.filter(function(b){ return b.getAttribute('aria-pressed')==='true'; })[0]||picks[0];
      load(cur,true);
    });
    if(picks.length) load(picks[0],false);
  }

  /* ---- 3b · kleurvergelijking: schuif de lijn opzij ---- */
  var klBox=$('#kleurKl'), klR=$('#kleurRange');
  if(klBox&&klR){
    var klTop=$('.kl__top',klBox), klH=$('.kl__h',klBox), zelfGedaan=false;
    var klZet=function(v){
      klTop.style.clipPath='inset(0 '+(100-v)+'% 0 0)';
      klH.style.left=v+'%';
    };
    klR.addEventListener('input',function(){ zelfGedaan=true; klZet(+klR.value); });
    klR.addEventListener('pointerdown',function(){ zelfGedaan=true; });
    klZet(+klR.value);

    /* eenmalig voordoen dat de lijn beweegt, zodra de sectie in beeld komt */
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!rustig && 'IntersectionObserver' in window){
      var klIO=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          klIO.disconnect();
          var punten=[50,22,78,50], start=null, duur=2600;
          var tik=function(t){
            if(zelfGedaan) return;
            if(start===null) start=t;
            var p=Math.min(1,(t-start)/duur), seg=p*(punten.length-1),
                i=Math.min(punten.length-2,Math.floor(seg)), f=seg-i,
                e2=f<.5 ? 2*f*f : 1-Math.pow(-2*f+2,2)/2,
                v=punten[i]+(punten[i+1]-punten[i])*e2;
            klZet(v); klR.value=v;
            if(p<1) requestAnimationFrame(tik);
          };
          requestAnimationFrame(tik);
        });
      },{threshold:.4});
      klIO.observe(klBox);
    }
  }

  /* ---- 4 · past hij? ---- */
  var room=$('#room'), wide=$('#wide'), door=$('#door');
  if(room&&wide&&door){
    var LEN_UP=150, LEN_FLAT=201, W=75, DOOR=75;
    var plek=function(){
      var r=+room.value||0, w=+wide.value||0, out=[];
      if(r>=LEN_FLAT) out.push(['','Ook languit met de beensteun uit past hij: dan is hij '+LEN_FLAT+' cm.']);
      else if(r>=LEN_UP) out.push(['no','Rechtop past hij ('+LEN_UP+' cm); languit met de beensteun uit vraagt '+LEN_FLAT+' cm.']);
      else out.push(['no','Te krap: rechtop '+LEN_UP+' cm, languit met de beensteun uit '+LEN_FLAT+' cm.']);
      out.push(w>=W?['','Breedte past: de stoel is '+W+' cm breed.']:['no','De stoel is '+W+' cm breed — '+w+' cm is te smal.']);
      $('#verdPlek').innerHTML=out.map(function(o){ return '<li class="'+o[0]+'">'+o[1]+'</li>'; }).join('');
    };
    var deur=function(){ var d=+door.value||0;
      $('#verdDoor').innerHTML = d>=DOOR
        ? '<li>Door een deur van '+d+' cm komt hij in één stuk naar binnen.</li>'
        : '<li class="no">'+d+' cm is smaller dan de '+DOOR+' cm die de stoel breed is. Bel ons — vaak halen we hem ter plekke uit elkaar.</li>'; };
    room.addEventListener('input',plek); wide.addEventListener('input',plek); door.addEventListener('input',deur);
    plek(); deur();
  }

  /* ---- 5 · specs ---- */
  var sb=$('#specBtn');
  if(sb) sb.addEventListener('click',function(){
    var g=$('#specgrid'), on=g.classList.toggle('all');
    sb.setAttribute('aria-expanded',on); sb.textContent=on?'Toon minder':'Toon alle kenmerken';
  });

  /* ---- 6 · rustige scroll-animatie: elementen komen zacht omhoog als je ze nadert ----
     De stijl wordt hier ingevoegd, niet in het CSS-bestand: zo kan er nooit iets
     onzichtbaar blijven staan als deze JS om welke reden dan ook niet draait. */
  var zacht = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if(zacht && 'IntersectionObserver' in window){
    var st=document.createElement('style');
    st.textContent='.ncp .nc-rise{opacity:0;transform:translateY(18px);transition:opacity .62s cubic-bezier(.22,.61,.36,1),transform .62s cubic-bezier(.22,.61,.36,1)}.ncp .nc-rise.is-in{opacity:1;transform:none}';
    document.head.appendChild(st);
    var rise=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting) return;
        e.target.classList.add('is-in'); rise.unobserve(e.target); });
    },{threshold:.12, rootMargin:'0px 0px -6% 0px'});
    [
      {els:$$('#massage .rv > *'), kolommen:2, stap:120},
      {els:$$('#functies .fgg'), kolommen:2, stap:120},
      {els:$$('#functies .fx figure'), kolommen:2, stap:120},
      {els:$$('#functies .fstrip img'), kolommen:4, stap:80},
      {els:$$('#kleur .klc'), kolommen:2, stap:120},
      {els:$$('#past .dfig'), kolommen:1, stap:0}
    ].forEach(function(g){
      g.els.forEach(function(el,i){
        el.classList.add('nc-rise');
        el.style.transitionDelay=((i % g.kolommen)*g.stap)+'ms';
        rise.observe(el);
      });
    });
  }

  /* ---- 7 · autoplay-clips pas starten als ze in beeld komen ---- */
  var loops=$$('video[autoplay]');
  if(loops.length && 'IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(es){
      es.forEach(function(e){ var v=e.target;
        if(e.isIntersecting){ v.play().catch(function(){}); }
        else if(!v.paused){ v.pause(); } });
    },{threshold:.25});
    loops.forEach(function(v){ v.muted=true; vio.observe(v); });
  }
})();